module.exports = __webpack_public_path__ + "img/bg-wiebe-elsinga.0b463ff3.jpg";